function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 2");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "1_Artikel",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1_Artikel_Artikel",
  transform: "translate(-531.000000, -110.000000)",
  fill: "#B5B5B5"
}, /*#__PURE__*/React.createElement("g", {
  id: "Produktname_001",
  transform: "translate(330.000000, 106.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(201.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 8.98030588,
  cy: 1.94823529,
  r: 1.94823529
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1; 0.2;",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  opacity: 0.2,
  cx: 4.63214118,
  cy: 3.36790588,
  r: 1.94823529
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.9s",
  values: "1; 0.2;",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  opacity: 0.3,
  cx: 1.94865882,
  cy: 7.07230588,
  r: 1.94823529
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.8s",
  values: "1; 0.2;",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  opacity: 0.4,
  cx: 1.95522353,
  cy: 11.6466353,
  r: 1.94823529
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.7s",
  values: "1; 0.2;",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  opacity: 0.5,
  cx: 4.64929412,
  cy: 15.3434118,
  r: 1.94823529
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.6s",
  values: "1; 0.2;",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  opacity: 0.6,
  cx: 9.00148235,
  cy: 16.7505882,
  r: 1.94823529
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.5s",
  values: "1; 0.2;",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  opacity: 0.7,
  cx: 13.3498588,
  cy: 15.3309176,
  r: 1.94823529
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.4s",
  values: "1; 0.2;",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  opacity: 0.8,
  cx: 16.0331294,
  cy: 11.6265176,
  r: 1.94823529
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.3s",
  values: "1; 0.2;",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  opacity: 0.9,
  cx: 16.0265647,
  cy: 7.05218824,
  r: 1.94823529
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.2s",
  values: "1; 0.2;",
  dur: "1s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 13.3327059,
  cy: 3.35541176,
  r: 1.94823529
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.1s",
  values: "1; 0.2;",
  dur: "1s",
  repeatCount: "indefinite"
}))))));

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.5e4e421c.svg";
export { ForwardRef as ReactComponent };